export default "__VITE_ASSET__KE3GP792__"